import React from 'react';
import {Badge} from 'reactstrap';
import {auth, constants} from '@neosvoc/nv-platform-core-common';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';

const COLOR_MAP = {
    [constants.PERMISSIONS.ADMIN]: 'warning',
};

const PrivilegeBadges = ({user}) => {
    const privileges = auth.getPermissions(...user.roles);
    if (!privileges.length) {
        return <Badge color="danger" pill><FormattedMessage {...messages.privileges.none} /></Badge>;
    }
    return privileges.map((p) => (
        <Badge key={p} className="mr-1" color={COLOR_MAP[p] || 'info'} pill>
            {messages.privileges[p] ? <FormattedMessage {...messages.privileges[p]} /> : p}
        </Badge>
    ));
};

export default PrivilegeBadges;
